import { get } from "@/helpers/get-set";

const isFeatureEnabled = (company, name) => {
    return Boolean(company.features.find(x => x === name));
}

export default {
    isEnabledChecklistMustBeCompletedToFinishTask: (company) => {
        return get(company, 'data.checklist_completed')
    },

    isFeatureMonitoringEnabled: (company) => {
        return isFeatureEnabled(company, 'monitoring')
    },
    isClientManagementDisabledForUsers: (company) => {
        return get(company, 'data.client_management_disabled_for_users')
    }
}